import React from "react";
import { CheckIcon, GlobeIcon, LockIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { OfferCountdown } from "../OfferCountdown";
import { ScarcityBar } from "../ScarcityBar";
import { valueStack, offerIncludes } from "../../data/bonuses";
import { MOCKUP_URL } from "../../data/checkout";
export function OfferSection() {
  const total = valueStack.reduce((sum, row) => sum + row.value, 0);
  return <section id="offer" className="w-full bg-navy px-4 py-16 sm:px-5 sm:py-24" data-id="element-286" data-mp="6irfxjk3l7ua">
      <div className="mx-auto max-w-2xl" data-id="element-287" data-mp="1pggw4lj1vcx">
        <h2 className="text-center font-serif text-[28px] font-black leading-tight text-white sm:text-4xl" data-id="element-288" data-mp="1oex9bqg40jl">
          Your Complete Interceptive Orthodontics Library
        </h2>
        <p className="mt-3 text-center text-lg text-white/80" data-id="element-289" data-mp="3nz98ink9i9ll">Everything organized in one digital collection.</p>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white shadow-2xl" data-id="element-290" data-mp="3j0pm6m1ravsp">
          <div className="bg-cream px-5 pt-6" data-id="element-291" data-mp="3exjjtphrlori">
            <img src={MOCKUP_URL} alt="The complete Interceptive Orthodontics Blueprint collection" className="mx-auto w-full max-w-sm" data-id="element-292" data-mp="1asaclp9rxo54" />
          </div>

          <div className="px-5 py-7 sm:px-8" data-id="element-293" data-mp="10ucpx67kbzem">
            <table className="w-full text-left" data-id="element-294" data-mp="10vnvnbkkjh8d">
              <thead data-id="element-295" data-mp="15se8lq12twpk">
                <tr className="border-b-2 border-navy text-xs font-extrabold uppercase tracking-wider text-muted" data-id="element-296" data-mp="15tz3jgrazhny">
                  <th className="pb-2 font-extrabold" data-id="element-297" data-mp="1tj1i2fqn4ue8">Included resource</th>
                  <th className="pb-2 text-right font-extrabold" data-id="element-298" data-mp="1ygjuwh7s3tri">Value</th>
                </tr>
              </thead>
              <tbody data-id="element-299" data-mp="1kh24jxeu48g1">
                {valueStack.map(row => <tr key={row.label} className="border-b border-navy/10" data-id="element-300" data-mp="1oivx1ievm654">
                    <td className="py-3 pr-3 text-[15px] font-semibold text-navy" data-id="element-301" data-mp="92oj0z7k0536">{row.label}</td>
                    <td className="py-3 text-right text-[15px] font-bold tabular-nums text-muted" data-id="element-302" data-mp="d4a0yyyy39k8">${row.value}</td>
                  </tr>)}
              </tbody>
              <tfoot data-id="element-303" data-mp="2ft07bonjywdh">
                <tr data-id="element-304" data-mp="2arubhhyliszq">
                  <td className="pt-4 text-base font-extrabold uppercase text-navy" data-id="element-305" data-mp="2arawoa48skpx">Total reference value</td>
                  <td className="pt-4 text-right text-xl font-black tabular-nums text-wine" data-id="element-306" data-mp="260cet63lvekk">
                    <s data-id="element-307" data-mp="212sz01r9etqi">${total} USD</s>
                  </td>
                </tr>
              </tfoot>
            </table>

            <div className="mt-8 rounded-2xl bg-cream px-4 py-6 text-center" data-id="element-308" data-mp="1x17d5qwqz546">
              <p className="text-sm font-bold uppercase tracking-wide text-muted" data-id="element-309" data-mp="1s135mqdthkq3">
                But today, your complete collection is only:
              </p>
              <p className="mt-1 font-serif text-7xl font-black leading-none text-cta" data-id="element-310" data-mp="1n42ysd958dxx">$27</p>
              <p className="mt-1 text-lg font-extrabold text-navy" data-id="element-311" data-mp="1i5jfkklxpg99">USD · One-Time Payment</p>
            </div>

            <ul className="mt-6 space-y-2.5" data-id="element-312" data-mp="3ch6g8nricaxk">
              {offerIncludes.map(item => <li key={item} className="flex gap-2.5 text-[15px] font-semibold text-navy" data-id="element-313" data-mp="3ky6tqzro6873">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-314" data-mp="3kwduw6nass9n" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-7" data-id="element-315" data-mp="3tslgfnej4l08">
              <CtaButton label="Yes! Give me instant access" data-id="element-316" data-mp="2kqv7pkqsp1u" />
            </div>

            <OfferCountdown data-id="element-317" data-mp="31zcfrt015brz" />
            <ScarcityBar data-id="element-318" data-mp="3204cx899zhkd" />

            <div className="mt-5 flex gap-3 rounded-2xl bg-navy/5 p-4" data-id="element-319" data-mp="320xapjq9awqd">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy" aria-hidden="true" data-id="element-320" data-mp="360658qt4eymz" />
              <p className="text-sm text-navy" data-id="element-321" data-mp="3azrcrpmcwfbb">
                <strong data-id="element-322" data-mp="3b23rzv0qcbko">Automatic currency conversion:</strong> the price is shown in your local currency at
                checkout, based on your location.
              </p>
            </div>

            <p className="mt-5 flex items-center justify-center gap-1.5 text-center text-sm font-medium text-muted" data-id="element-323" data-mp="q9jx02o1pr4d">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-324" data-mp="vapqw3tfzkfh" />
              Secure checkout · Digital Educational Collection
            </p>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-325" data-mp="1z8l0vtele1th">
          <p className="font-serif text-2xl font-bold leading-snug text-white sm:text-3xl" data-id="element-326" data-mp="2d69i8r9gaqts">
            Don’t let another growing-patient case send you searching through disconnected educational
            resources.
          </p>
          <p className="mt-4 text-lg text-white/80" data-id="element-327" data-mp="2n3ean8tw3ij1">
            Keep a structured clinical reference collection available whenever you want to review early
            orthodontic assessment and planning concepts.
          </p>
          <div className="mx-auto mt-8 max-w-xl" data-id="element-328" data-mp="2vz3q718npioi">
            <CtaButton label="Get my Interceptive Orthodontics Blueprint™" data-id="element-329" data-mp="2rv5pim3onztc" />
            <OfferCountdown tone="dark" data-id="element-330" data-mp="35uxchcc6gqjh" />
          </div>
        </div>
      </div>
    </section>;
}